export const POST_BODY_MAX_LENGTH = 4000;

export function formatPostBodyLength(length: number): string {
  return `${length} / ${POST_BODY_MAX_LENGTH}文字`;
}

export function hasPostContent(body: string, hasAttachment: boolean): boolean {
  return body.trim().length > 0 || hasAttachment;
}

export function hasReplySubmissionContent(
  body: string,
  attachmentCount: number,
  hasPendingAttachment: boolean,
): boolean {
  return hasPostContent(body, attachmentCount > 0 || hasPendingAttachment);
}

/**
 * ACT欄（自由入力）の値を送信用の sage フラグへ写像する。
 * 将来 sage 以外のコマンドを追加する場合はこの関数を拡張する
 * （呼び出し側の入力状態・送信パラメータの構造は変更不要）。
 */
export function resolveActInputToSage(actInput: string): boolean {
  return actInput
    .trim()
    .split(/\s+/)
    .some((act) => act.toLowerCase() === "sage");
}
